import { format } from "date-fns";

function slugify(str) {
  return str.trim()
    .toLowerCase()
    .replace(/[^a-z0-9 -]/g, '') // remove any non-alphanumeric characters
    .replace(/\s+/g, '-') // replace spaces with hyphens
    .replace(/-+/g, '-'); // remove consecutive hyphens
}

class Roles {
    constructor(admin, host) {
        this.admin = admin;
        this.host = host;
    }
}

class AuthUser {
    constructor(firebaseUser, roles) {
        this.email = firebaseUser.email;
        this.roles = roles;
    }
}

class Broadcast {
    constructor(broadcastId, broadcastData, userEmails, broadcastImages, broadcastAudios) {
        this.id = broadcastId;

        this.title = broadcastData.title || '';
        this.location = broadcastData.location || '';
        this.tracklist = broadcastData.tracklist || '';
        this.broadcastDate = broadcastData.broadcastDate ? broadcastData.broadcastDate.toDate() : undefined;
        this.description = broadcastData.description || '';
        this.notes = (broadcastData.notes || []).map(note => {
            const createdAt = new Date(note.created_at);
            const createdAtFormatted = createdAt.valueOf() ? format(createdAt, "yyyy/MM/dd hh:mm:ss") + "+00:00" : "n/a";
            return {content: note.content, createdBy: note.created_by, createdAtFormatted, status: note.status};
        });

        this.userEmails = userEmails || [];
        this.images = broadcastImages ||
            (broadcastData.images || []).map(imageData => new BroadcastImage(imageData));
        this.audios = broadcastAudios ||
            (broadcastData.audio_filepaths || []).map(filepath => new BroadcastAudio(filepath));

    }
    get hasAudio() {
        return !!this.audios.length;
    }
    get hasImage() {
        return !!this.images.length;
    }
    get hasTracklist () {
        return !!this.tracklist;
    }
    get broadcastDateFormatted() {
        if (!this.broadcastDate) return "n/a";

        return format(this.broadcastDate, "yyyy/MM/dd");
    }
    get audioFilenameTrunk() {
        const parts = [
            this.id,
            slugify(this.title),
        ];
        if (this.broadcastDate) parts.push(format(this.broadcastDate, "yyyy-MM-dd"));

        return parts.join('-');
    }
}
class BroadcastAudio {
    constructor(filepath, url) {
        this.filepath = filepath;
        this.url = url || '';
    }
}
class BroadcastImage {
    constructor(image, url) {
        this.author = image.author;
        this.title = image.title;
        this.source = image.source;
        this.filepath = image.filepath;
        this.use = image.use;
        this.url = url || '';
    }
}

function payoutDate(timeStamp) {
    if(!timeStamp) return null;

    const cutoffDate = new Date(timeStamp);
    const threeDaysMs = 3 * 24 * 3600 * 1000;
    return new Date(cutoffDate.getTime() + threeDaysMs);
}

class HostShow {
    constructor(hostShowData) {
        this.showAlias = hostShowData.showAlias;
        this.name = hostShowData.name;
        this.hours = hostShowData.hours;
        this.hoursConfirmed = hostShowData.hoursConfirmed;
        this.amountCents = hostShowData.amountCents;
        this.payoutConfirmed = hostShowData.payoutConfirmed;
        this.invoiceUrl = hostShowData.invoiceUrl;
        this.payoutAt = payoutDate(hostShowData.payoutAt);
    }
    get isPayoutPhase() {
        return this.amountCents > 0;
    }
    get isConfirmed() {
        return !this.isPayoutPhase && this.hoursConfirmed === this.hours
            || this.isPayoutPhase && !!this.payoutConfirmed;
    }
    get donationIsConfirmed() {
        return this.payoutConfirmed === 'donate';
    }
}

export {
    AuthUser,
    Broadcast,
    BroadcastAudio,
    BroadcastImage,
    HostShow,
    Roles,
};
